<template>
<div>
    <b-container >
          <b-row>
            <b-col  v-if="!generic_module_view" cols="8">
                 <div class="input-content">
                 </div>
            </b-col>
            <b-col  cols="8">
                 <div v-if="!generic_module_view" class="input-content">
                 <input class="input-course-title" placeholder="Module Name" v-model="current_module.title" v-validate="'required'" name="name"/>
                    <span class="input-error-msg">{{ errors.first('name') }}</span>
                 </div>
            </b-col>
            <b-col cols="4">
                 <button  v-if="!generic_module_view" class="button large-button" @click="createModule">CREATE</button>
                 <button v-if="generic_module_view" class="button large-button" @click="saveModule">SAVE</button>

            </b-col>
        </b-row>
    </b-container>
	<div class="row mt-3 min-width-module-view">
        <div class="col-lg-4">
            <div class="h-25 mr-5">
                <div v-if="!currentImage" >
                <picture-input 
                    ref="pictureInput"
                    accept="image/jpeg,image/png" 
                    size="10" 
                    button-class="button"
                    :custom-strings="{
                    upload: '<h1>Bummer!</h1>',
                    drag: 'Drag or click to upload an image'
                    }"
                    @change="onChange"
                  >
                </picture-input>
                </div>
                <div v-if="currentImage"> 
                     <img class="picture-holder" :src="current_module.image" />
                      <button @click="removeImage" class="mt-1 ml-6 button button-small">Remove Image</button>
                </div>

                <div class="mt-1 ml-1 row-manually" v-if="generic_module_view">
                     <h5 >ID {{current_module.id}}</h5>
                    <div class="line_holder">
                       
                     <input class="line_holder-2" type="checkbox" :disabled="true" v-model="current_module.has_quiz">
                    <b class="line_holder-2">Quiz</b>
                    
                    <button  v-if="moduleRelationButtonText == 'quiz_version'" class="button line_holder-2 mb-8 ml-1" @click="openPairModal = !openPairModal">Create Quiz Version</button>
                    <button  v-if="moduleRelationButtonText == 'non_quiz_version'" class="button line_holder-2 mb-8 ml-1" @click="openNonQuizModal = !openNonQuizModal">Create Base Version</button>

                    <router-link  class="ml-2 line_holder-2" v-else  tag="a" target="_blank" :to="{name: 'sme.module.view', params:{id: modulePairID}}">
                    <strong class="text-primary">{{modulePairButton}}</strong>
                    </router-link>

                    <button
                        v-if="shouldDisplayNewNtmLink"
                        type="button"
                        class="button"
                        @click="() => loadInNewNTM()"
                    >Load in new NTM</button>

                    </div>
                    <div class="line_holder mt-2">
                        <input
                            class="line_holder-2 pointer"
                            type="checkbox"
                            v-model="current_module.in_library"
                            @change="event => handleToggleIncludeInLibrary(event)"
                        >
                        <b class="line_holder-2">Include in Public Library</b>
                    </div>
                    <div class="line_holder mt-2">
                        <input
                            class="line_holder-2 pointer"
                            type="checkbox"
                            v-model="current_module.require_survey"
                        >
                        <b class="line_holder-2">Require Survey</b>
                    </div>
                    <div class="line_holder mt-2">
                        <img width="15" src="../../../assets/images/icons/solid/clock.svg" />
                             {{totalDuration}}
                    </div>

                   

              
                 
                    <hr>
                    <div class="row ml-0">
                         <div class="row ml-0 mr-2">
                        <div>
                              <span><h6>Date Created</h6></span>
                              <span><p> {{current_module.created_at }}</p></span>
                        </div>
                        </div>
                        <div class="row ml-0">
                        <div class="">
                            <span><h6>Date Modified</h6></span>
                            <span><p> {{current_module.updated_at }} </p></span>
                        </div>
                        </div>
                    </div>
                   <hr>
            
                </div>
                <div class="mb-3">
                    <button
                        class="button line_holder-2 mb-8 ml-1"
                        @click="openCeuTimeModal"
                    >Edit CEU Time</button>
                </div>
                <div class="mb-3">
                    <button
                        class="button line_holder-2 mb-8 ml-1"
                        @click="openAssocReqModal"
                    >Edit Associated Requirements</button>
                </div>
                <div class="mb-3">
                    <button
                        class="button line_holder-2 mb-8 ml-1"
                        @click="duplicateModuleV2"
                    >Duplicate V2</button>
                </div>
                <div class="mt-2 mb-3">
                    <label>Keywords</label>
                    <button class="button line_holder-2 mb-8 ml-1" @click="open_new_keywords = !open_new_keywords">+</button>
                    <v-select ref="categorySection" placeholder="Keywords" :searchable="true" label="name"  
                        v-model="keywords_selected" :options="keywords_list" multiple>
                    </v-select>
                </div>

                <div class="mt-2 mb-3">
                    <label>Skills</label>
                    <v-select ref="categorySection" placeholder="Skills" :searchable="true" label="name"  
                        v-model="skill_selected" :options="skill_list" multiple>
                    </v-select>
                </div>

                <div class="mt-2 mb-3">
                    <label>Disciplines</label>
                    <v-select ref="categorySection" placeholder="Disciplines" :searchable="true" label="name"  
                        v-model="discipline_selected" :options="discipline_list" multiple>
                    </v-select>
                </div>

                <div class="mt-2 mb-3">
                    <label>Locations</label>
                    <v-select ref="categorySection" placeholder="Locations" :searchable="true" label="name"  
                        v-model="location_selected" :options="location_list" multiple>
                    </v-select>
                </div>
                <slot name="program-agency"> 
                   
                </slot>
         
            </div>
        </div>
    
        <div class="col-lg-8 col-lg-auto">
            <!-- <div class="column col-12"> -->
            <div class="row">
                <b-tabs  v-model="tabIndex" class="column col-12">
                    <b-tab title="+"  class="no-background">
                        <div class="ml-5 mt-3 row">
                            <div class="col-10 ">
                                <div class="input-content">
                                    <div
                                        v-if="user_meta_actions.includes('can_manage_module_secondary_names')"
                                        class="row d-flex justify-content-end mb-2"
                                    >
                                        <button
                                            type="button"
                                            class="button gray-content"
                                            @click="openModuleSecondaryNamesModal"
                                        >Edit Secondary Names</button>
                                    </div>

                                    <div class="row">
                                        <h6 class="">Add New Language Option</h6>

                                        <v-select
                                            v-model="new_language"
                                            label="name"
                                            :class="{
                                                'green bg-gray v-select-no-height input-disabled': disable_select,
                                                'green bg-gray v-select-no-height':!disable_select
                                            }"
                                            :options="available_languages"
                                            searchable
                                            @input="addLanguage"
                                        ></v-select>

                                        <span
                                            v-if="current_route == 'sme.module.create'"
                                            class="input-error-msg"
                                        >Please, Create Module First in order to Add Language</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </b-tab>
                
                  <b-tab class="" :title-link-class="{ update_trigger_hack: edit_tree }" :key="index" v-for="(player, index) in module_languages">
                       <template slot="title">
                        {{player.value}}
                        <img v-if="edit_tree" width="12" src="../../../assets/images/icons/solid/times_white.svg" 
				            					class="red-content remove-language"  @click.prevent="showModalDeleteLanguage(player)"
				            				/>
                      </template>
                      <div v-if="selected_language !=null">
                         <div class="ml-2 mt-3 row">
                            <div class="col-10 ">
                                <div class="input-content">
                                        <input
                                            v-model="current_module.name[selected_language.key]"
                                            v-validate="''"
                                            name="Language_specific_name"
                                            class="input-course-title"
                                            placeholder="Module Language Specific Name"
                                        />
                                        <span class="input-error-msg">{{ errors.first('Language_specific_name') }}</span>
                                    </div>
                                </div>
                            </div>
                            <div  class="ml-2 mt-1 row">
                                <div class="col-10">
                                    <h6>Description</h6>

                                    <textarea
                                        v-model="current_module.description[selected_language.key]"
                                        v-validate="''"
                                        name="Language_specific_description"
                                        class="form-control mb-2 deneme"
                                        placeholder="Module Description"
                                    ></textarea>

                                    <div class="input-content">
                                        <span class="input-error-msg">{{ errors.first('Language_specific_description') }}</span>
                                    </div>
                                </div>
                            </div>
                         
                              <program-lesson-view 
                                v-on="$listeners"
                                ref="genericviewlesson"
                                :generic_module_view="true"
                                :current_lesson="current_lesson"
                                :lessons="current_module.lessons"
                                :wider_view="false"
                                :current_module="current_module"
                                :selected_language="selected_language"
                                :module_available_languages="module_languages"
                                :current_tab="tabIndex"
                                @hasLessonVideoModule="saveModule"
                                @updateLessonName="updateLessonName"

                                ></program-lesson-view>
                        </div>
                    </b-tab> 
            
                 </b-tabs>
    
                 <div v-if="!generic_module_view" class="mt-2 put_content_right">
                     
                   <img width="15" src="../../../assets/images/icons/solid/clock.svg" />
                 
                    <input class="ml-2" type="checkbox" :disabled="true" v-model="current_module.has_quiz">
                    <b>Quiz</b>
                   
                 </div>
            <!-- </div> -->
            </div>
       
            
        </div>
    </div>
    <div v-if="openPairModal">
        <b-modal v-model="openPairModal" title="Choose Model Type" no-close-on-backdrop
        :ok-disabled="picked == '' || (picked == 'Use Existing' && lesson_quiz_pair == '')"
        cancel-title="Close" @cancel="closeModelSelectionView" @ok="LessonSelection"
        >
            <div>
                  <input type="radio" id="two" value="Create New Placeholder" v-model="picked">
                 <label for="two">Create New Placeholder</label>
            </div>
            <br>
            <div>
                 <input type="radio" id="one" value="Use Existing" v-model="picked">
                 <label for="one">Use Existing</label>
            </div>
            <br>
            <div v-if="show_lesson_table">
                <v-select name="Lesson List" :searchable="true" track-by="value" :resetOnOptionsChange="false"
                @search="getExistingLessons($event)" ref="modalSelect"
                v-model="lesson_quiz_pair" :options="existing_lessons" label="item_data"
                v-validate="'required'">
                <template slot="no-options">
                    <template v-if="search_key_lesson != ''">
                        No results found for <em>{{ search_key_lesson }}</em>.
                    </template>
                    <template v-else>
                       Start typing to search for a lesson
                    </template>
                </template>
              
                <template slot="option" v-if="search_key_lesson != '' " slot-scope="option">
                    <span><b>ID: </b> {{option.id}} <b> Title: </b>{{ option.title }}</span>
                    
                </template> 
            </v-select>
            <span class="input-error-msg">{{ errors.first('country_code') }}</span>
            </div>
        </b-modal>
    </div>
    <div v-if="openNonQuizModal">
         <b-modal v-model="openNonQuizModal" title="Create Base Model" ok-title="Create"
        cancel-title="Cancel" @cancel="closeModelSelectionView" @ok="baseModalCreate"
        >
        <p  class="mb-2">
           A new module without lesson <b>{{quizLesson[0].id}} {{quizLesson[0].title}} </b>will be created. Are you sure you want to continue?
        </p>
        </b-modal>
    </div>
    <div v-if="openLanguageRemoveModal">
         <b-modal v-model="openLanguageRemoveModal" title="Remove Language" ok-title="Remove"
        cancel-title="Cancel" @cancel="closeModelSelectionView" @ok="removeLanguageModal"
        >
        <p  class="mb-2">
          {{languageToRemove.value}} will be removed from this module. Are you sure you want to continue?
        </p>
        </b-modal>

    </div>
    <div v-if="openLanguageRemoveModal && modulePairID != ''">
         <b-modal v-model="openLanguageRemoveModal" title="Module Pair Relation and Language Remove" ok-title="Remove"
        cancel-title="Cancel" @cancel="closeModelSelectionView" @ok="removeLanguageModal"
        >
        <p  class="mb-2">
            This module has a pair relation, removing 
          {{languageToRemove.value}} will be affect Module ID: {{modulePairID}}. Are you sure you want to continue?
        </p>
        </b-modal>

    </div>

    <div v-if="isEditingModuleSecondaryNames">
        <b-modal
            v-model="isEditingModuleSecondaryNames"
            title="Edit Module Names"
            cancel-title="Cancel"
            ok-title="Save"
            size="xl"
            no-close-on-backdrop
            @cancel="closeModuleSecondaryNamesModal"
            @ok="handleSaveModuleNames"
        >
            <div class="alias-container-selected p-2 mb-2">
                <h6 class="mb-2" :style="{ color: '#00797C' }">Main Name</h6>

                <div
                    v-for="language in module_languages"
                    :key="`module-primary-name-${language.key}`"
                    class="d-flex align-items-center mb-2"
                >
                    <div class="container d-flex align-items-center">
                        <span class="mr-2">{{ language.value }}</span>
                        <span
                            class="form-control"
                            :style="{ backgroundColor: 'transparent' }"
                        >{{ current_module.name[language.key] }}</span>
                    </div>

                    <div>
                        <button
                            type="button"
                            class="button gray-content"
                            @click="editPrimaryName(language.key)"
                        >Edit</button>
                    </div>
                </div>
            </div>

            <h6 class="mt-4 mb-2">Secondary Names</h6>

            <template v-if="module_secondary_names.length">
                <div
                    v-for="(name, index) in module_secondary_names"
                    :key="`module-secondary-name-${index}`"
                    class="alias-container d-flex justify-content-between p-2 mb-2"
                >
                    <div class="container">
                        <div
                            v-for="language in module_languages"
                            :key="`module-secondary-name-${index}-${language.key}`"
                            class="d-flex align-items-center mb-2"
                        >
                            <span class="mr-2">{{ language.value }}</span>
                            <input v-model="name.name[language.key]" class="form-control">
                        </div>
                    </div>

                    <div>
                        <button
                            type="button"
                            class="button red-content"
                            @click="handleRemoveModuleName({ index })"
                        >Remove</button>
                    </div>
                </div>
            </template>

            <div v-else class="py-2 mb-2">
                No secondary names yet.
            </div>

            <div class="">
                <button
                    type="button"
                    class="button green-content"
                    @click="handleAddModuleName"
                >Add name</button>
            </div>
        </b-modal>
    </div>

    <div v-if="isEditingCeuTime">
        <b-modal
            v-model="isEditingCeuTime"
            title="Edit CEU Time"
            cancel-title="Cancel"
            ok-title="Save"
            size="xl"
            no-close-on-backdrop
            @cancel="closeCeuTimeModal"
            @ok="handleSaveCeuTime"
        >
            <ValidationObserver ref="observer">
                <b-form
                    slot-scope="{ validate }"
                    @submit.prevent="validate().then(handleSaveCeuTime)"
                >
                    <h6 class="mb-2">States</h6>

                    <template v-if="current_module.ceu_time.length">
                        <div
                            v-for="(state, index) in current_module.ceu_time"
                            :key="`module-ceu-time-state-${index}-${state.state}`"
                            class="w-100 alias-container d-flex justify-content-between p-2 mb-2"
                        >
                            <div class="w-100 d-flex">
                                <ValidationProvider
                                    v-slot="{ errors }"
                                    rules="required"
                                    name="State"
                                    slim
                                >
                                    <div class="w-25 d-flex flex-column input-content">
                                        <v-select
                                            v-model="state.state"
                                            name="State 0"
                                            :options="ceu_states"
                                            placeholder="State"
                                            index="code_2"
                                            label="name"
                                        ></v-select>
                                        <span v-if="errors[0]" class="input-error-msg">{{ errors[0] }}</span>
                                    </div>
                                </ValidationProvider>

                                <ValidationProvider
                                    v-slot="{ errors }"
                                    rules="required"
                                    name="CEU Type"
                                    slim
                                >
                                    <div class="w-25 d-flex flex-column input-content ml-4">
                                        <v-select
                                            v-model="state.ceu_type"
                                            :options="ceu_types"
                                            placeholder="CEU Type"
                                            index="value"
                                            label="label"
                                        ></v-select>
                                        <span v-if="errors[0]" class="input-error-msg">{{ errors[0] }}</span>
                                    </div>
                                </ValidationProvider>

                                <ValidationProvider
                                    v-slot="{ errors }"
                                    rules="required"
                                    name="CEU Value"
                                    slim
                                >
                                    <div class="w-25 d-flex flex-column input-content ml-4">
                                        <input
                                            v-model="state.ceu_value"
                                            placeholder="CEU Value"
                                        >
                                        <span v-if="errors[0]" class="input-error-msg">{{ errors[0] }}</span>
                                    </div>
                                </ValidationProvider>

                                <span v-if="state.ceu_type === 1" class="ml-2 mt-2">Units</span>
                                <span v-if="state.ceu_type === 2" class="ml-2 mt-2">Hours</span>
                            </div>

                            <div class="mt-2">
                                <button
                                    type="button"
                                    class="button red-content"
                                    @click="handleRemoveCeuState({ index, record: state })"
                                >Remove</button>
                            </div>
                        </div>
                    </template>

                    <div v-else class="py-2 mb-2">
                        No States yet.
                    </div>

                    <div class="">
                        <button
                            type="button"
                            class="button green-content"
                            @click="handleAddCeuState"
                        >Add State</button>
                    </div>

                    <div class="d-flex justify-content-end mt-4">
                        <button type="button" class="button gray-content" @click="closeCeuTimeModal">Cancel</button>
                        <button type="submit" class="button green-content ml-2">Save</button>
                    </div>
                </b-form>
            </ValidationObserver>

            <template v-slot:modal-footer>
                <div></div>
            </template>
        </b-modal>
    </div>

    <EditAssocReqModal
        v-if="isEditingAssocReq"
        :module-id="current_module.id"
        :assoc-req="current_module.assoc_reqs || []"
        @close="closeAssocReqModal"
        @save="handleSaveAssocReq"
        @refresh="$emit('refreshModule')"
    />

    <div v-if="open_new_keywords">
      <b-modal v-model="open_new_keywords" id="modal-sm" size="sm" title="Create Keyword" ok-title="Create" @cancel="closeModelSelectionView" @ok="addNewCategory(1)" :ok-disabled="!category_add_enabled || selected_category_ ==''">
        <div>
            <div>
                 <input type="text" class="border-bottom" v-model="selected_category_" @input="searchCategory($event)" />
            </div>

            <span v-if="!category_add_enabled" class="float-right mt-2 input-error-modal">Use a unique name</span>
        </div>
      </b-modal>
    </div>

    <b-modal
        ref="public-library-validations"
        title="Module Not Ready"
        ok-title="Enable Public Library"
        @ok="handleAddToPublicLibraryAnyway"
    >
        <span>Module is missing the following:</span>
        <ul class="pt-2">
            <li v-if="!public_library_validations.hasModuleImage">Module Image</li>
            <li v-if="!public_library_validations.hasModuleLesson">At least one lesson</li>
            <li v-if="!public_library_validations.hasModuleNames">Every language has a Module Name</li>
            <li v-if="!public_library_validations.hasLessonTincans">Every lesson in every language has a Video</li>
            <li v-if="!public_library_validations.hasLessonNames">Every lesson in every language has Name</li>
            <li v-if="!public_library_validations.hasLessonDescriptions">Every lesson in every language has a Description</li>
            <li v-if="!public_library_validations.hasLessonDurations">Every lesson has duration</li>
        </ul>
        <span>If you enable 'Include in Public Library', don't forget to click Save after.</span>
    </b-modal>
</div>
    
</template>
<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import PictureInput from 'vue-picture-input';
import ProgramLessonView from '../SharedViews/ProgramLessonView'
import EditAssocReqModal from '../SharedViews/EditAssocReqModal.vue';
import MixinSME from '../MixinSME';
import { EventBus } from './../../../event_bus.js';
export default{
    props:[
        'course_data', 'current_module', 'current_lesson','generic_module_view','module_languages','available_languages'
    ],
    components: {
		PictureInput, ProgramLessonView,
        ValidationObserver, ValidationProvider,
        EditAssocReqModal,
	},
    inject: ['$validator'],
    mixins: [MixinSME],
    created: function(){

    },
    computed: {
        moduleRelationButtonText: function(){
            if(this.current_module.base_module_id == '' && 
                this.current_module.quiz_module_id == ''){
                    if(this.current_module.has_quiz == false){
                        return 'quiz_version'
                        
                    }else{
                        if(this.current_module.lessons.length>0){
                            return 'non_quiz_version'
                        }else{
                            return ''
                        }
                    }
            }else{
                return ''
            }
        },
         quizLesson: function(){
            return this.current_module.lessons.filter(elem => elem.has_quiz == 1)
        },
        modulePairID: function(){
            if(this.current_module.base_module_id == ''){
                return this.current_module.quiz_module_id
            }else{
                return this.current_module.base_module_id
            }
        },
        modulePairButton: function(){
            if(this.current_module.base_module_id != '' && this.current_module.base_module_id != undefined){
                return 'Go To Base Version'
            }
            if(this.current_module.quiz_module_id != '' && this.current_module.quiz_module_id != undefined){
                return 'Go To Quiz Version'
            }

        }
        ,
        lesson_search:{
            get(){ return this.lesson_search},
            set(val){this.lesson_search = val}

        },
        disable_select: function(){
            if(this.available_languages.length == 0){
                return true
            }else{
                return false
            }

        },
        organizationLength: function(){
            if(typeof this.current_module.organizations === 'object'){
                return Object.keys(this.current_module.organizations).length
            }
            else if(Array.isArray(this.current_module.organizations)){
                return this.current_module.organizations.length
            }
            else{
                return 0
            }
        },
        currentImage: function(){
            if(this.generic_module_view){
                if(this.current_module.image != null && this.current_module.image != 'http://nevvon.com/logo.png'){
                    return true
                }else{
                    return false
                }
            }
        },
        totalDuration: function(){
            //calculate the total length of lessons
            if(this.current_module.lessons){
                let temp_dur=0

                this.current_module.lessons.filter( lesson=>{
                    if(typeof lesson.duration_int == 'string'){
                      temp_dur += parseInt(lesson.duration_int)
                    }else{
                         temp_dur += lesson.duration_int
                    }
                })
                return this.secondsToHms(temp_dur)
            }else{
                return 0
            }
          
        },
        selected_language: function(){
            if(this.tabIndex == 0){
                EventBus.$emit('selected_laguage_change',null);
                return null
            }else{
                EventBus.$emit('selected_laguage_change',this.module_languages[this.tabIndex-1])
                return this.module_languages[this.tabIndex-1]
            }
        },
        shouldDisplayNewNtmLink() {
            return true;
        },
    },
    data : function(){
        return{
            user_meta_actions: localStorage.getItem('meta_actions'),
            openNonQuizModal:false,
            lesson_quiz_pair:'',
            current_route: this.$route.name,
            vmsProps:{
                generic_module_view:true,
                current_lesson:this.current_lesson,
                lessons:this.current_module.lessons,
                wider_view:false

            },
            tabIndex:0,
            modalShow: false,
            moduleTitle:"Lord of the Rings",
            description:'Some explanation here',
            notes:'Some notes here',
            lesson_edit:false,
            module_info:{
                id:'',
                name:'',
                description : '',
                notes:'',
                image:''
                
            },
            lesson:{
                name:'',
                description:''
            },
            existing_lessons : [],
            show_lesson_table:false,
            attachmentsDropzoneOptions: {
                url : this.config.UPLOAD_ATTACHMENT_FILES,
                thumbnailWidth: 50,
                maxFilesize: 500,
                maxFiles : 100,
                addRemoveLinks : true,
                timeout : 300000,
                headers : {
                    'Autrollization' : localStorage.getItem('token')
                }
            },
            current_image:'',
            new_language:'',
            languages_all:'',
            openPairModal:false,
            open_new_keywords:false,
            selected_category_:'',
            category_add_enabled: false,
            keywords_text_input:'',
            keywords_list:[],
            skill_list:[],
            discipline_list:[],
            location_list:[],
            keywords_selected:[],
            skill_selected:[],
            discipline_selected:[],
            location_selected:[],
            picked:'',
            search_key_lesson:'',
            edit_tree: false,
            openLanguageRemoveModal:false,
            languageToRemove:'',
            language_to_open:'',
            tags_list:[],
            tags_selected:[],
            isEditingModuleSecondaryNames: false,
            module_secondary_names: [],
            public_library_validations: {
                hasModuleImage: false,
                hasModuleNames: false,
                hasLessonDescriptions: false,
                hasModuleLesson: false,
                hasLessonTincans: false,
                hasLessonNames: false,
                hasLessonDurations: false,
            },
            ceu_states: [],
            ceu_types: [
                { value: 1, label: 'CEU Time' },
                { value: 2, label: 'CEU Hours' },
            ],
            isEditingCeuTime: false,
            isEditingAssocReq: false,
        }
    },
    watch:{
        picked: function(val){
            if(this.picked == 'Use Existing' && (this.show_lesson_table == false)){
               this.show_lesson_table = true
            }else{
                this.show_lesson_table = false
            }
        },
        module_languages:function(val, oldval){
             this.module_languages.filter((e,i) =>{
                 if(e.key == this.language_to_open.code_2){
                    this.$nextTick(()=>{
                        this.tabIndex = i+1
                        return
                    });
                 }
             })
        }
    },
    mounted:function(){
        this.sortModuleTags();
        this.getCategories();
        this.getModuleSecondaryNames();
        this.getCeuRegions();
        EventBus.$on('openLesson', (index) => {
                this.openLessonGeneric(index)
		});
        EventBus.$on('edit_tree', (val) => {
            this.$nextTick(()=>{
                this.$forceUpdate()    
                this.edit_tree = !val
            });
		});
    },
    methods:{
        searchCategory(){
           this.checkCategoryMatch(this.selected_category_, 'category_add_enabled');
        },
        checkCategoryMatch(name, condition){
            if (this.tags_list.filter(function(e) { return e.name === name; }).length > 0) {
                this[condition] = false
            }else{
               this[condition] = true
            }
        },
        sortModuleTags(){
            this.keywords_selected.splice(0);
            this.skill_selected.splice(0);
            this.discipline_selected.splice(0);
            this.location_selected.splice(0);

            if (this.current_module.sme_tags) {
                this.current_module.sme_tags.forEach(tag => {
                    if (tag.sme_tag_type_id == 1) {
                            this.keywords_selected.push(tag);
                        } else if (tag.sme_tag_type_id == 2) {
                            this.skill_selected.push(tag);
                        } else if (tag.sme_tag_type_id == 3) {
                            this.discipline_selected.push(tag);
                        } else if (tag.sme_tag_type_id == 4) {
                            this.location_selected.push(tag);
                        }
                });
            }
        },
        collapseModuleTags(){
            this.current_module.sme_tags.splice(0);

            this.keywords_selected.forEach(tag => {
                this.current_module.sme_tags.push(tag);
            });
            this.skill_selected.forEach(tag => {
                this.current_module.sme_tags.push(tag);
            });
            this.discipline_selected.forEach(tag => {
                this.current_module.sme_tags.push(tag);
            });
            this.location_selected.forEach(tag => {
                this.current_module.sme_tags.push(tag);
            });
        },
        addNewCategory: function(type){
            var params = {
                name: this.selected_category_,
                sme_tag_type_id: type
            }
            this.$store.dispatch('createCategory', params).then((res)=>{{ 
                this.getCategories()
            }
            }).catch((error) => {
                console.log(error)
            })
            this.selected_category_ = ''
            this.category_add_enabled = false
        },
        getCategories: function(){
            this.keywords_list.splice(0);
            this.skill_list.splice(0);
            this.discipline_list.splice(0);
            this.location_list.splice(0);

            var params = {}
            this.$store.dispatch('getCategories', params).then((res)=>{{ 
                this.tags_list = res.data.data
                this.tags_list.forEach(tag => {
                    if (tag.sme_tag_type_id == 1) {
                        this.keywords_list.push(tag);
                    } else if (tag.sme_tag_type_id == 2) {
                        this.skill_list.push(tag);
                    } else if (tag.sme_tag_type_id == 3) {
                        this.discipline_list.push(tag);
                    } else if (tag.sme_tag_type_id == 4) {
                        this.location_list.push(tag);
                    }
                });
            }
            }).catch((error) => {
                console.log(error)
            })
        },

        async getModuleSecondaryNames() {
            try {
                const data = {
                    moduleId: this.current_module.id,
                };

                const response = await this.$store.dispatch('getModuleSecondaryNames', data);
                console.log('get response', response);

                this.module_secondary_names = response;
            } catch (error) {
                console.log('error', error);
            }
        },

        editPrimaryName(languageKey) {
            const languageIndex = this.module_languages.findIndex(language => (language.key === languageKey));
            this.tabIndex = (languageIndex + 1);

            this.isEditingModuleSecondaryNames = false;
        },

        handleAddModuleName() {
            const newAlias = this.module_languages.reduce((acc, language) => {
                acc.name[language.key] = '';
                return acc;
            }, {
                module_id: this.current_module.id,
                name: {},
            });

            this.module_secondary_names.push(newAlias);
        },

        handleRemoveModuleName({ index }) {
            this.module_secondary_names.splice(index, 1);
        },

        async handleSaveModuleNames() {
            try {
                const data = {
                    moduleId: this.current_module.id,
                    data: this.module_secondary_names,
                };

                const response = await this.$store.dispatch('setModuleSecondaryNames', data);

                this.getModuleSecondaryNames(); // refresh data
                this.isEditingModuleSecondaryNames = false;

                this.$snotify.success('Updated secondary names successfully.');
            } catch (error) {
                console.log('error', error);
            }
        },

        handleAddModuleTags() {
            let temp_arr = this.keywords_text_input.split(',');
            this.keywords_list = this.keywords_list.concat(temp_arr);
            this.keywords_text_input = '';

            console.log('New List: ', this.keywords_list);
            addNewCategory(1);
        },

        removeLanguageModal:function(){
            this.$emit('removeModalLanguage', this.languageToRemove)
        },
        showModalDeleteLanguage: function(val){
            this.languageToRemove = val
            this.openLanguageRemoveModal = !this.openLanguageRemoveModal
        },
        getExistingLessons : function(key_word){
            if(key_word == undefined || key_word == '' || this.$refs.modalSelect.search == ''){
                this.search_key_lesson = ''
                this.existing_lessons = []
                return
            }else{
                this.search_key_lesson = key_word
            }

            var params = {
                filters : {
                    search : this.search_key_lesson
                }
            }
            this.$store.dispatch('getLessonsWithQuiz', params).then((res) => {
                setTimeout( () => {
                  if(this.search_key_lesson != '') {
                    this.existing_lessons = res.data.data
                    for(let i in this.existing_lessons){
                        this.existing_lessons[i].item_data =  this.existing_lessons[i].title + ' ' +  this.existing_lessons[i].id
                    }
                  }
                },300)
            });
		},
        LessonSelection: function(){
               var params={
                 id: this.current_module.id,
                }
            
            if(this.picked == 'Use Existing'){
                params.quiz_lesson_id = this.lesson_quiz_pair.id
              
            }else{
                params.quiz_lesson_id = null
                params.quiz_lesson_title = 'New Lesson With Quiz'

            }
            this.$store.dispatch('pairModuleQuiz', params).then((res) => {
                    this.$emit('currentModuleQuizAdd',res.data.data.id)
                    let route = this.$router.resolve({name: 'sme.module.view',params:{id: res.data.data.id} });
                    // let route = this.$router.resolve('/link/to/page'); // This also works.
                    window.open(route.href, '_blank');
            });

        },
        baseModalCreate: function(){
            var params = {
                id:this.current_module.id,
            }
            this.$store.dispatch('pairModuleNonQuiz', params).then((res) => {
                 this.$emit('currentModuleBaseAdd',res.data.data.id)
                let route = this.$router.resolve({name: 'sme.module.view',params:{id: res.data.data.id} });
                    // let route = this.$router.resolve('/link/to/page'); // This also works.
                window.open(route.href, '_blank');

            })
        },
        closeModelSelectionView: function(){
            this.search_key_lesson = ''
            this.openPairModal = false
            this.open_new_keywords = false
            this.openNonQuizModal = false
            this.picked = ''
            this.existing_lessons = []
            this.openLanguageRemoveModal = false
            this.languageToRemove = ''
        },
        openLessonGeneric: function(val){
            if(this.selected_language != null){
                setTimeout( () => {
                    this.$refs.genericviewlesson[this.tabIndex -1].open_lesson(val)

                },300)
                
        }

        },
        onChange : function(image){
            if(this.generic_module_view == false){
                this.current_module.image = image;
                return
            }
            
            this.current_module.image = image
                var params = {
                id : this.current_module.id,
                image : image
            }
       
            if (image) {
                this.$store.dispatch('updateModuleImage', params).then((res) => {
                    
                    //this.$snotify.success('Image updated successfully');
                    this.current_module.image = image;
                });
            }
        },
        removeImage: function(){
            this.current_module.image = null
            

        },
        addLanguage: function(){
            if(this.new_language == null || this.new_language == ''){
                return
            }
            if(!this.generic_module_view){
             this.$emit('addNewLessonModule',[...this.module_languages].pop());

            }
            this.language_to_open = this.new_language
            this.$emit('addModalLanguage', {
                key:this.new_language.code_2,
                code_2:this.new_language.code_2,
                value:this.new_language.name,
                name:this.new_language.name
            })
            this.new_language = ''
        },

        openModuleSecondaryNamesModal() {
            this.isEditingModuleSecondaryNames = true;
        },

        closeModuleSecondaryNamesModal() {
            this.isEditingModuleSecondaryNames = false;
            this.getModuleSecondaryNames();
        },

        async getCeuRegions() {
            const states = await this.$store.dispatch('getRegions', 'US');
            this.ceu_states = states;
        },

        openCeuTimeModal() {
            this.isEditingCeuTime = true;
        },

        closeCeuTimeModal() {
            this.isEditingCeuTime = false;
            this.$emit('refreshModule');
        },

        async handleRemoveCeuState({ index, record }) {
            await this.$store.dispatch('removeCeuTimeState', record);
            this.current_module.ceu_time.splice(index, 1);
        },

        handleAddCeuState() {
            this.current_module.ceu_time.push({
                state: null,
                ceu_type: null,
                ceu_value: null,
            });
        },

        async handleSaveCeuTime() {
            if (!this.current_module.ceu_time.length) {
                this.isEditingCeuTime = false;
                return;
            }

            for (const record of this.current_module.ceu_time) {
                if (!record.id) {
                    // handle add
                    record.module_id = this.current_module.id;
                    await this.$store.dispatch('addCeuTimeState', record);
                } else {
                    // handle update
                    await this.$store.dispatch('updateCeuTimeState', record);
                }
            }

            this.isEditingCeuTime = false;
            this.$emit('refreshModule');
        },

        handleCreateModule() {
            this.$emit('createModule', this.current_module);
        },
        createModule: function(){
            this.$validator.validateAll().then((result) => {
                if (result) {
                    this.handleCreateModule();
                }
            });
        },
        saveModule: function(){
            this.collapseModuleTags();

            this.$validator.validateAll().then((result) => {
                if(result){
                    this.$emit('saveModule');
                }
            });
        },
        updateLessonName: function(name, id){
            this.$emit('updateLessonName', name,id)
        },
        handleToggleIncludeInLibrary (event) {
            // console.log('current module', this.current_module);
            if (!this.current_module.in_library) {
                this.current_module.in_library = 0;
                return;
            }

            if (this.current_module.image) {
                if (this.current_module.image !== 'http://nevvon.com/logo.png') {
                    this.public_library_validations.hasModuleImage = true;
                }
            }

            if (this.current_module.name && Object.values(this.current_module.name).every(name => !!name)) {
                this.public_library_validations.hasModuleNames = true;
            }

            if (this.current_module.description && Object.values(this.current_module.description).every(description => !!description)) {
                this.public_library_validations.hasLessonDescriptions = true;
            }

            if (this.current_module.lessons && this.current_module.lessons.length) {
                this.public_library_validations.hasModuleLesson = true;
            }

            console.log('lessons', this.current_module.lessons);
            if (this.current_module.lessons && this.current_module.lessons.length) {
                const addedLanguages = Object.keys(this.current_module.name);

                const doesEveryLessonHaveTincans = this.current_module.lessons.every((lesson) => {
                    // language[0] is the language key (ex: EN), language[1] is the has_tincan boolean value
                    const hasTincans = Object.entries(lesson.has_tincan)
                        .filter(language => addedLanguages.includes(language[0]))
                        .every(language => !!language[1]);

                    return hasTincans;
                });

                if (doesEveryLessonHaveTincans) {
                    this.public_library_validations.hasLessonTincans = true;
                }
            }

            if (this.current_module.lessons && this.current_module.lessons.length) {
                const addedLanguages = Object.keys(this.current_module.name);

                const doesEveryLessonHaveNames = this.current_module.lessons.every((lesson) => {
                    // language[0] is the language key (ex: EN), language[1] is the has_tincan boolean value
                    console.log('entries', Object.entries(lesson.name));
                    const hasNames = Object.entries(lesson.name)
                        .filter(language => addedLanguages.includes(language[0]))
                        .every(language => !!language[1]);

                    return hasNames;
                });

                console.log('doesEveryLessonHaveNames', doesEveryLessonHaveNames);
                if (doesEveryLessonHaveNames) {
                    this.public_library_validations.hasLessonNames = true;
                }
            }

            if (this.current_module.lessons && this.current_module.lessons.length) {
                const everyLessonHasDuration = this.current_module.lessons.every(lesson => (lesson.duration_int > 1));
                if (everyLessonHasDuration) {
                    this.public_library_validations.hasLessonDurations = true;
                }
            }

            // console.log('validations', this.public_library_validations);

            const isModuleValid = Object.values(this.public_library_validations).every(isTrue => !!isTrue);

            if (isModuleValid) {
                this.current_module.in_library = 1;
            } else {
                this.current_module.in_library = 0;
                this.$refs['public-library-validations'].show();
                event.target.checked = false; // mandatory hack to keep checkbox visually unchecked
            }
        },
        handleAddToPublicLibraryAnyway() {
            this.current_module.in_library = 1;
        },
        loadInNewNTM() {
            let moduleId = this.current_module.id;

            if (this.current_module.base_module_id) {
                moduleId = this.current_module.base_module_id;
            }

            window.open(`${this.config.NEW_NTM_URL}/modules/${moduleId}`, '_blank');
        },
        openAssocReqModal() {
            this.isEditingAssocReq = true;
        },

        closeAssocReqModal() {
            this.isEditingAssocReq = false;
            this.$emit('refreshModule');
        },

        handleSaveAssocReq() {
            closeAssocReqModal();
        },
        duplicateModuleV2() {
            var params = {
                id : this.current_module.id
            }
            this.$store.dispatch('duplicateModuleV2', params).then((res) => {
                console.log(res);
                window.open(`${this.config.NEW_NTM_URL}/modules/${res.data.module.id}`, '_blank');
            }).catch((error) => {
                console.log(error);
            });
        },
    }
}
</script>
<style scoped>

.deneme{
    margin-top: 0px !important;
}
.no-border{
    border-top: none;
    border-left: none;
    border-right: none;
    border-radius: 4px;
    border-bottom: none;
}
.border-bottom{
    width: 100%;
    border-top: none;
    border-left: none;
    border-right: none;
    border-radius: 4px;
}
.input-error-modal{
    font-size: 12px;
    color: red;
}

.input-content .input-course-title {
    font-size: 1.6em;
}
.input-content .input-lesson-title {
    font-size: 1.2em;
}
.deneme{
    background-color:#f5f5f5;
    min-height: 100px !important;
}
.hadi{
    background-color:#f5f5f5;
    border: 5px solid white;
    border-radius: 8px;
}
.general-border{
    border: 5px solid white;
    border-radius: 8px;
}
.white-background{
    background-color:#fff !important;
}
.put_content_right{
    margin-left:auto;
}
.desciption-width{
    min-width: 350px;
}
.picture-holder{
    min-height: 224px;
    min-width:224px;
    max-width:224px;
    max-height:224pc;
}

.alias-container-selected {
    background-color: #BFF2ED;
    border-radius: 8px;
}
.alias-container:hover {
    background-color: #f5f5f5;
    border-radius: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/sme/SharedViews/GenericModuleView.vue